import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Badge } from 'react-bootstrap';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarClientes, filtarClientes } from '../../actions/clientes';

import FiltrosClientes from './FiltrosClientes';
import EliminarCliente from './EliminarCliente';

const Clientes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Clientes',
            path: '/clientes'
        }
    ];

    const dispatch =  useDispatch();

    const { usuario } = useSelector(state => state.auth);
    const { listado } = useSelector(state => state.clientes);

    const [clientes, setClientes] = useState([]);

    const [clienteEliminar, setClienteEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => [row.nombre, row.apellido_paterno, row.apellido_materno].filter(Boolean).join(' ') || '-',
            grow: 2
        },
        {
            name: 'Empresa',
            sortable: true,
            selector: row => row.nombre_comercial || 'Sin definir',
            grow: 2
        },
        {
            name: 'RFC',
            sortable: true,
            selector: row => row.rfc || 'Sin definir'
        },
        {
            name: 'Membresía',
            sortable: true,
            selector: row => row.membresia || 'Sin definir',
            cell: row => row.membresia
                ? <h6 className="mb-0"><Badge pill bg={row.membresia_total === 0 ? 'info' : 'success'}>{row.membresia}</Badge></h6>
                : <h6 className="mb-0"><Badge pill bg="secondary">Sin definir</Badge></h6>,
            grow: 2
        },
        {
            name: 'Celular',
            sortable: true,
            selector: row => row.celular || '-',
            cell: row => row.celular
                ? <span>{row.celular} <a href={`https://wa.me/${row.celular.replace(/\D/g, '')}`} target="_blank" rel="noreferrer"><i className="fab fa-whatsapp text-success"></i></a></span>
                : '-'
        },
        {
            name: 'Email',
            sortable: true,
            selector: row => row.email || '-',
            grow: 2
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.clientes?.eliminar &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarCliente(row)}><i className="fas fa-trash text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.clientes?.editar &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/clientes/editar/${row._id}`}><i className="fas fa-edit text-warning"></i></Link>
                        }
                        {
                            usuario?.permisos?.clientes?.detalles &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/clientes/detalles/${row._id}`}><i className="fas fa-circle-info text-info"></i></Link>
                        }
                    </div>
                )
            }, 
            grow: 0.5
        }
    ];

    /* Filtros de busqueda */
    const handleFiltrosBusqueda = () => {
        dispatch(filtarClientes(true));
    }

    /* Eliminar cliente */
    const handleEliminarCliente = (cliente) => {
        setClienteEliminar(cliente);
    }

    useEffect(() => {
        dispatch(buscarClientes({
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            celular: null,
            email: null
        }));
    }, []);

    useEffect(() => {
        setClientes(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosClientes />
            <EliminarCliente cliente={clienteEliminar} reestablecerCliente={handleEliminarCliente} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Clientes</h3>        

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary me-2" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>

                        {
                            usuario?.permisos?.clientes?.agregar &&
                                <Link to="/clientes/nuevo"><button className="btn btn-primary">Agregar cliente</button></Link>
                        }
                    </div>            

                    <div className="mt-3">
                        <DataTable
                            columns={columns}
                            data={clientes}
                            noDataComponent="Aún no hay registros"
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Clientes;